module.exports = __webpack_public_path__ + "./images/f342d3aa3b942e7fc8a6f7715f1a79d0.webp";